import React from 'react';
import { useMutation } from '@apollo/client';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { createAuditMutation } from '../../../components/RequestForms/api';
import { cancelRequestMutation } from '../api';
import axios from 'axios';

export const CancelModal = (props: any) => {
  const [show, setShow] = React.useState(false);
  const [submit, setSubmit] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { user } = useSelector((state: any) => ({ user: state.user }));
  const [createAudit] = useMutation(createAuditMutation);
  const [cancelRequest] = useMutation(cancelRequestMutation);


  const createAuditForAsset = (rowdata) => {
    const audit = {
      barcode: rowdata?.barcode,
      createdBy: user.adId,
      lastUpdatedBy: user.adId,
      comment: 'Request has been cancelled',
      updatedOn: new Date(),
      entryType: 'Cancelled',
      requestId: rowdata.id,
    };
    createAudit({ variables: audit }).catch((err) => console.log('Error: /frontend/src/pages/HomePage/components/CancelModal//createAuditForAsset', err));
  };

  const cancelReq = (requestId: any) => {
    setSubmit(true);
    cancelRequest({
      variables: {
        requestId: requestId,
      },
    }).then((res) => {
      try {
        axios.post(`${(window as any)._env_.REACT_APP_SERVER}/request/statusUpdateEmail`, {
          userRequest: { ...props.data, statusUpdateStatus: 'Cancelled' },
        }).catch((err) => {
          console.log('Error: frontend/src/pages/HomePage/components/CancelModal//cancelReq/lno46', err)
        })
      } catch (e) {
        setSubmit(false);
        handleClose();
        console.log("couldn't cancel request: ", e);
      }

      createAuditForAsset(props.data);
    });
    setSubmit(false);
    setSubmitted(true);
    setTimeout(() => {
      handleClose();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }, 1000);
  };

  return (
    <>
      <Button onClick={handleShow}>
        <i className='fa fa-times'></i>
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Request {props.data.requestNumber}</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel this request?</Modal.Body>
        <Modal.Footer>
          <Button variant='info' onClick={handleClose}>
            No
          </Button>
          <Button variant='primary' onClick={() => cancelReq(props.data.id)}>
            Yes
            {submit && <Spinner className='ml-1' as='span' animation='border' size='sm' role='status' aria-hidden='true' />}
            {submitted && <i className='fa fa-check ml-1' />}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
